<script lang="ts" generics="T">
  import type { ColumnDefinitions } from "/@lib/types/Table"
  import { Table } from "@tastyworks/ui-library"

  type Props = {
    items?: T[]
    columns: ColumnDefinitions
    message?: string | undefined
  }

  let { items = [], columns, message = undefined }: Props = $props()
</script>

<Table.Root class="basis-1/3 overflow-x-scroll border-2">
  <Table.Header class="sticky top-0 text-center">
    {#each columns as { name, width }}
      <Table.HeaderCell span={width ?? 1}>{name}</Table.HeaderCell>
    {/each}
  </Table.Header>
  <Table.Body>
    {#if message}
      <Table.Body class="text-center">{message}</Table.Body>
    {:else}
      {#each items as item, i}
        <Table.BodyRow index={i}>
          {#each columns as { dataFormatter, width }}
            <Table.BodyCell
              class="border-r-[1px] border-solid px-1"
              span={width ?? 1}
            >
              {dataFormatter(item) ?? ""}
            </Table.BodyCell>
          {/each}
        </Table.BodyRow>
      {/each}
    {/if}
  </Table.Body>
</Table.Root>
